import { theme } from 'aimo-ui';
import WelcomeSignedContent from 'components/account/WelcomeSignedContent';
import BGView from 'components/common/BGView';
import useBottomMenuHeight from 'hooks/useBottomMenuHeight';
import useIsLoggedIn from 'hooks/useIsLoggedIn';
import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components/native';
import {
  ScreenContainer,
  ScreenWrapper,
  StyledIllustrationImage,
  StyledImage,
} from 'styles/ContainerStyles';
import { isWeb } from 'utils/deviceUtils';
import LoginStates from './LoginStates';

const ImageWrapperForOnboardingV2 = styled.View`
  justify-content: flex-end;
  flex: 1;
  transform: translate(0, 52px);
  z-index: 999;
  margin-top: -60px;
`;

const contentContainerStyle = { flexGrow: 1 };

const AccountDefault: React.FC = () => {
  const { t } = useTranslation();
  const { isLoggedIn } = useIsLoggedIn();
  const tabBarHeight = useBottomMenuHeight();

  const renderServiceScreenInWeb = () => {
    return (
      <>
        <StyledImage
          testID="account-main-image"
          width={309}
          height={300}
          center
          source={require('assets/images/illustration-account.png')}
        />
        <LoginStates
          fixedHeader={true}
          loginText={t('account.notSISUDescription')}
        />
      </>
    );
  };

  const renderAccountScreenInNative = () => {
    return (
      <ScreenWrapper
        contentContainerStyle={contentContainerStyle}
        padding={0}
        tabBarHeight={tabBarHeight}>
        <ImageWrapperForOnboardingV2>
          <StyledIllustrationImage
            testID="account-main-image"
            center
            resizeMode="contain"
            source={require('assets/images/illustration-account.png')}
          />
        </ImageWrapperForOnboardingV2>
        <LoginStates fixedHeader loginText={t('account.notSISUDescription')} />
      </ScreenWrapper>
    );
  };

  const renderer = () =>
    isWeb ? (
      <ScreenWrapper tabBarHeight={tabBarHeight}>
        {isLoggedIn ? <WelcomeSignedContent /> : renderServiceScreenInWeb()}
      </ScreenWrapper>
    ) : (
      <>
        {isLoggedIn ? (
          <BGView noRoundedCorners noMargins paddings={{ top: 0 }}>
            <WelcomeSignedContent />
          </BGView>
        ) : (
          renderAccountScreenInNative()
        )}
      </>
    );

  return (
    <ScreenContainer
      background={isWeb ? theme.colors.white : theme.colors.lightBg.pink}
      mt={isWeb ? 170 : 0}>
      {renderer()}
    </ScreenContainer>
  );
};

export default AccountDefault;
